import proptypes from 'prop-types';

const { bool, func, instanceOf, string } = proptypes;

export const OverviewPropTypes = {
  apiKey: string.isRequired,
  handleCardClick: func,
  isMobileOverlay: bool,
  reviewStatistics: instanceOf(Object),
  hideSecondaryRatings: bool,
  disableOverlayOnClick: bool
};